import ReactComponent from '../../app/ReactComponent'
import {Button, Popconfirm} from 'antd'
import {DeleteOutlined} from '@ant-design/icons'

export class CancelRewardsButton extends ReactComponent {
  state = {
    open: false

  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Popconfirm
        title={this.props.title}
        description={this.props.description}
        okText={'Ano'}
        cancelText={'Ne'}
        icon={false}
        onConfirm={() => {
          this.props.onConfirm(this.props.item)
        }}
        disabled={this.props.disabled}
      >
        <Button
          type="link"
          danger
          disabled={this.props.disabled}
          onClick={() => {
            void this.updateState({open: !this.state.open})
          }}
          icon={<DeleteOutlined/>}
        >Zrušit</Button>
      </Popconfirm>
    )
  }
}